import { SendRounded } from "@mui/icons-material";

export const send = (props) => {
  return <SendRounded {...props} />;
};
